import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    mainContnet: {
      display: "flex",
      width: "100%",
      [theme.breakpoints.down("1205")]: {
        gap: "20px",
        flexWrap: "wrap",
      },
    },
    avatarContainer: {
      display: "flex",
      gap: "20px",
    },
    userDetails: {
      maxWidth: "160px",
      width: "max-content",
    },
    username: {
      fontSize: "18px",
      fontWeight: "600",
      paddingBottom: "12px",
    },
    row: { display: "flex", flexDirection: "column" },
    col: { display: "flex", gap: "8px" },
    wrapper: {
      display: "flex",
      alignItems: "center",
      gap: "64px",

      [theme.breakpoints.down("1830")]: {
        justifyContent: "space-between",
        alignItems: "flex-start",
      },
      [theme.breakpoints.down("1022")]: {
        gap: "16px",
      },
      [theme.breakpoints.down("864")]: {
        flexDirection: "column",
      },
    },
    contentWrapper: {
      display: "flex",
      maxWidth: "1924px",
      padding: "0 20px",
      gap: "64px",
      [theme.breakpoints.down("1830")]: {
        flexDirection: "column",
        width: "100%",
        justifyContent: "flex-start",
        gap: "20px",
        padding: "0",
      },
    },
    fieldTitle: {
      fontSize: "14px",
      fontWeight: "400",
      color: theme.palette.text.tertiary,
    },
    fieldValue: {
      fontSize: "14px",
      fontWeight: "600",
      color: theme.palette.text.brand_tertiary,
    },
    feesTitle: {
      fontSize: "16px",
      fontWeight: "500",
      color: theme.palette.text.secondary,
    },
    feesValue: {
      fontSize: "16px",
      fontWeight: "600",
      color: theme.palette.text.brand_tertiary,
    },
    deduction: {
      color: theme.palette.text.error_primary,
    },
    avatarWrapper: {
      alignItems: "center",
      backgroundColor: "#FFF",
      borderRadius: "50%",
      boxShadow:
        "0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
      display: "flex",
      height: "80px",
      justifyContent: "center",
      position: "relative",
      width: "80px",
      marginTop: "-10px",
    },
    defaultAvatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "72px",
      width: "72px",

      "& img": {
        height: "36px",
        width: "36px",
      },
    },
    finalNetAmount: {
      color: theme.palette.text.primary,
      fontSize: "18px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
    },
    list: {
      display: "flex",
      gap: "20px",
      [theme.breakpoints.down("864")]: {
        flexDirection: "column",
      },
    },
  };
});
